import { FC } from 'react'

import { NodeViewWrapper, NodeViewProps } from '@tiptap/react'
import clsx from 'clsx'

import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons'

/**
 * Wrapper for video, audio, image and embed extensions with loading spinner
 * @param param0 - props passed to the extension
 */
export const Container: FC<NodeViewProps & { className?: string }> = ({
  node,
  selected,
  children,
  className,
}) => {
  const { loading } = node.attrs

  return (
    <NodeViewWrapper
      as="figure"
      className={clsx(
        'border-2 relative',
        selected ? 'border-actionPrimary-500' : 'border-transparent',
        loading && 'opacity-40',
        className,
      )}
    >
      {loading && (
        <SpinnerIcon
          className="absolute inset-0 m-auto w-16 h-16 animate-spin"
          width="auto"
          height="auto"
        />
      )}

      {children}

      {!selected && (
        <div
          className="absolute top-0 bottom-0 left-0 right-0 h-full w-full"
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
          }}
        />
      )}
    </NodeViewWrapper>
  )
}
